import React from "react"
import {Form, Input, Select} from "antd"

type Props = {
  label: string
  name: string[]
  required: boolean
}

export const MappingFormItem: React.FC<Props> = ({
  label,
  name,
  required,
}): React.ReactElement =>
  <Form.Item label={label} required={required}>
    <Input.Group compact>
      <Form.Item
        name={[ ...name, "type"]}
        noStyle
        rules={[{required: true, message: "Mapping type is required"}]}
      >
        <Select placeholder="Select mapping type">
          <Select.Option value="constant">Constant</Select.Option>
          <Select.Option value="field">Field</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item
        name={[ ...name, "value"]}
        noStyle
        rules={[{required: true, message: "Value is required"}]}
      >
        <Input style={{width: "50%"}}/>
      </Form.Item>
    </Input.Group>
  </Form.Item>